export default __webpack_public_path__ + "static/media/login2.fffbf244.png";